import*as o from"./_polyfill-node.tty.js";import{getAugmentedNamespace as r}from"./_commonjsHelpers.js";var m=r(o);export{m as default};
